import { ALL_FEATURE_GROUPS, ALL_FEATURES } from '../features';
import { buildFeatureGroupRegistry } from './feature-group-registry';

export type { FeatureGroupRegistry } from './feature-group-registry';
export { buildFeatureGroupRegistry, expandGuids } from './feature-group-registry';

/**
 * Pre-built registry of all known feature groups across all products.
 * Resolved once at module load time — group GUID expansion is O(1) at request time.
 */
export const FEATURE_GROUP_REGISTRY = buildFeatureGroupRegistry(ALL_FEATURE_GROUPS, ALL_FEATURES);
